/**
 * api.js — thin wrapper around the Annie English backend API.
 *
 * BASE_URL defaults to '' so the CRA dev-proxy (port 3000 → 8080) works.
 * In production set REACT_APP_API_URL=https://api.annieenglish.com
 */
const BASE_URL = process.env.REACT_APP_API_URL || '';

/**
 * Fetches a fresh single-use CSRF token and sets the csrf_token cookie.
 * @returns {Promise<string>}
 */
export async function fetchCsrfToken() {
  const res = await fetch(`${BASE_URL}/api/csrf-token`, { credentials: 'include' });
  if (!res.ok) throw new Error('Không thể lấy CSRF token');
  const { csrfToken } = await res.json();
  return csrfToken;
}

/**
 * Submits a consultation-booking request.
 * @param {{ name, phone, course, mode, email?, level?, experience? }} data
 * @param {string} token  CSRF token from fetchCsrfToken()
 * @returns {Promise<void>}  resolves on 201, rejects with human-readable Error
 */
export async function submitBooking(data, token) {
  const res = await fetch(`${BASE_URL}/api/bookings`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': token },
    body: JSON.stringify(data),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    if (body.fields) {
      throw new Error(
        Object.entries(body.fields)
          .map(([f, m]) => `${f}: ${m}`)
          .join('; ')
      );
    }
    throw new Error(body.error || `Lỗi máy chủ (${res.status})`);
  }
}
